import { Icons } from '@arpeggi/ui'
import { FC } from 'react'
import { Flex } from '../../../../../components/core/Flex'
import Text from '../../../../../components/core/Text/Text'

interface InstructionType {
  title: string
  description: string
}

interface Props {
  instructions: InstructionType[]
}

const Instruction: FC<{ instruction: InstructionType }> = ({ instruction }) => {
  return (
    <Flex css={{ gap: '8px', flexDirection: 'column' }}>
      <Flex css={{ alignItems: 'center', gap: '16px' }}>
        <Icons.SoundUpload />
        <Text size="16" fontWeight="bold">
          {instruction.title}
        </Text>
      </Flex>
      <Text size="14" type="secondary">
        {instruction.description}
      </Text>
    </Flex>
  )
}

export const Instructions: FC<Props> = ({ instructions }) => {
  return (
    <Flex css={{ gap: '24px', flexDirection: 'column' }}>
      {instructions.map((instruction, index) => (
        <Instruction key={index} instruction={instruction} />
      ))}
    </Flex>
  )
}
